import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    TextField,
    Typography,
    Autocomplete
} from '@mui/material';
import Switch from '@mui/material/Switch';
import React, { useEffect, useState } from 'react';
import { ERROR_MESSAGES, SUCCESS_MESSAGES } from '../../../configs/messages';
import { ROUTES_LIST } from '../../../helpers/routesList';
import showMessage from '../../../helpers/showMessage';
import { useSnackbar } from 'notistack';
import { useParams } from 'react-router';
import { useHistory } from 'react-router-dom';
import { deleteData } from '../../../helpers/deleteData';
import { getDataItem } from '../../../helpers/getDataItem';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { LOCAL_STORAGE_USER, SESSION_NAME } from '../../../configs/constants';
import { sendFormData } from '../../../helpers/sendFormData';


export default function ChannelForm({ isEdit }) {
    const [errors, setErrors] = useState({});
    const [showDeleteValidation, setShowDeleteValidation] = useState(false);
    const [isToggle, setIsToggle] = useState(false)
     const user = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));
    const [initialData, setInitialData] = useState({
        name: '',
        description: '',
        vooChannelId: '',
        channelTypeId: '',
        active: isToggle,
        vooChannels:null,
        channelTypes:null,
        imageUrl: '',
        image: null,
    });
    useEffect(() => {
        setIsToggle(initialData.active);
    }, [initialData.active]);
    const [vooChannelList, setVooChannelList] = useState([]);
    const [channelTypeList, setChannelTypeList] = useState([]);
    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory();
    const { id } = useParams();

    let submitUrl = 'channel';
    let channelTypeUrl = 'channel/channel-types';

    if (isEdit) {
        submitUrl += `/role/${id}`;
    }

    useEffect(() => {
        let isActive = true;

        if (!isEdit) {
            return () => (isActive = false);
        }

        getDataItem(submitUrl)
            .then(({ data }) => {
                if (isActive) {
                    delete data.data?.id;
                        setInitialData(data.data); 
                }
            })
            .catch((error) => {
                console.error(error);
                showMessage(
                    error.response?.data?.message
                        ? error.response.data.message
                        : ERROR_MESSAGES.REQUEST_FAIL,
                    enqueueSnackbar,
                    'error',
                );
            });

        return () => (isActive = false);
    }, [isEdit, submitUrl, enqueueSnackbar]);

    useEffect(() => {
        getDataItem(channelTypeUrl)
            .then(({ data }) => {
                setChannelTypeList(data.data);
            })
            .catch((error) => {
                console.error(error);
                showMessage(
                    error.response?.data?.message
                        ? error.response.data.message
                        : ERROR_MESSAGES.REQUEST_FAIL,
                    enqueueSnackbar,
                    'error',
                );
            });
    }, [enqueueSnackbar]);

    const validate = () => {
        let tempErrors = { ...errors };
        const requiredMessage = ERROR_MESSAGES.FILL_THE_FIELD;
        if ('name' in initialData) {
            tempErrors.name = initialData.name ? '' : requiredMessage;
        }
        if ('description' in initialData) {
            tempErrors.description = initialData.description ? '' : requiredMessage;
        }
        // if ('vooChannelId' in initialData) {
        //     tempErrors.vooChannelId = initialData.vooChannelId ? '' : requiredMessage;
        // }
        if ('channelTypeId' in initialData) {
            tempErrors.channelTypeId = initialData.channelTypeId ? '' : requiredMessage;
        }

        setErrors({
            ...tempErrors,
        });

        return tempErrors;
    };

    const handleImageInsert = (e) => {
        const uploadedFiles = e.target.files;

        if (uploadedFiles && uploadedFiles.length > 0 && uploadedFiles[0].size > 2097152) {
            showMessage(
                ERROR_MESSAGES.FILE_SIZE_TOO_BIG,
                enqueueSnackbar,
                'error',
            );
            setInitialData({
                ...initialData,
                image: null,
                imageUrl: null,
            });
        } else if (uploadedFiles && uploadedFiles.length > 0) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setInitialData({
                    ...initialData,
                    image: uploadedFiles[0],
                    imageUrl: reader.result,
                });
            };

            reader.readAsDataURL(uploadedFiles[0]);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === "channelTypeId") {
            const selectedType = channelTypeList.find(type => type.id === value);
            setInitialData({
                ...initialData,
                channelTypes: selectedType,
                channelTypeId: selectedType.id
            });
        } else {
            setInitialData({
                ...initialData,
                [name]: value
            });
        }
    
    };
    const handleToggle = () => {
        setIsToggle((prevToggle) => !prevToggle);
        setInitialData({
            ...initialData,
            active: !isToggle,
        });
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        const tempErrors = validate();

        for (const key in tempErrors) {
            if (tempErrors[key]) {
                showMessage(
                    ERROR_MESSAGES.FILL_THE_FORM,
                    enqueueSnackbar,
                    'error',
                );
                return;
            }
        }

        const requestBody = { ...initialData };
        delete requestBody.imgUrl;
        console.log("initial data end bna", initialData)
        sendFormData(requestBody, submitUrl, isEdit)
            .then(() => {
                showMessage(SUCCESS_MESSAGES.ADDED_DATA, enqueueSnackbar);
                history.push(ROUTES_LIST.epgPage);
            })
            .catch((error) => {
                console.error('Error submitting data:', error); // Log the error
                showMessage(
                    error.response?.data?.message
                        ? error.response.data.message
                        : ERROR_MESSAGES.REQUEST_FAIL,
                    enqueueSnackbar,
                    'error',
                );
            });
    };

    const handleDelete = () => {
        deleteData(submitUrl)
            .then(() => {
                showMessage(SUCCESS_MESSAGES.DELETED_DATA, enqueueSnackbar);
                history.push(ROUTES_LIST.channelList);
            })
            .catch((error) => {
                console.error(error);
                showMessage(
                    error.response?.data?.message
                        ? error.response.data.message
                        : ERROR_MESSAGES.REQUEST_FAIL,
                    enqueueSnackbar,
                    'error',
                );
            });
    };

    return (
        <>
            <form onSubmit={handleSubmit} autoComplete="false">
                <Grid
                    container
                    direction="column"
                    spacing={2}
                    sx={{ width: '100%' }}
                >
                    <Grid
                        item
                        container
                        spacing={2}
                        direction="column"
                        sx={{ width: '100%' }}
                    >
                        <Grid item>
                            <TextField
                                value={initialData.name}
                                variant="standard"
                                label="Нэр"
                                fullWidth
                                name="name"
                                onChange={handleInputChange}
                                error={Boolean(errors.name)}
                                helperText={errors.name}
                                disabled={isEdit}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                value={initialData.description}
                                variant="standard"
                                label="Тайлбар"
                                fullWidth
                                type="description"
                                name="description"
                                onChange={handleInputChange}
                                error={Boolean(errors.description)}
                                helperText={errors.description}
                            />
                        </Grid>
                        <Grid item>
                            <Autocomplete
                                options={channelTypeList}
                                getOptionLabel={(option) => option.name}
                                value={channelTypeList.find(type => type.id === initialData.channelTypes?.id) || null}
                                onChange={(event, newValue) => {
                                    handleInputChange({
                                        target: {
                                            name: 'channelTypeId',
                                            value: newValue ? newValue.id : '',
                                        },
                                    });
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Сувгийн төрөл"
                                        variant="standard"
                                        fullWidth
                                        name="channelTypeId"
                                        error={Boolean(errors.channelTypes?.id ?? "")}
                                        helperText={errors.channelTypes?.id ?? ""}
                                    />
                                )}
                            />
                        </Grid>
                    <Grid item container direction="column" gap="20px">
                        <div>
                            {initialData.posterUrl && (
                                <img
                                    src={initialData.posterUrl}
                                    alt="зураг"
                                    style={{
                                        height: '300px',
                                        width: '400px',
                                        objectFit: 'cover',
                                    }}
                                />
                            )}
                        </div>
                        {/* {errors.image ? (
                            <InputErrorMessage errorMessage={errors.image} />
                        ) : null} */}
                        <div>
                            <p style={{ fontSize: '12px' }}>
                                Зургийн харьцаа 4:3 (800x600), зургийн хэмжээ
                                дээд 2mb
                            </p>
                            <Button variant="contained" component="label">
                                <input
                                    hidden
                                    accept="image/*"
                                    type="file"
                                    onChange={handleImageInsert}
                                />
                                Poster зураг оруулах
                            </Button>
                        </div>
                    </Grid>
                        <Grid
                            item
                            container
                            direction="row"
                            justifyContent="space-between"
                        >
                            <Grid item>
                                <Button
                                    variant="contained"
                                    color="warning"
                                    type="button"
                                    onClick={() => history.goBack()}
                                >
                                    <ArrowBackIcon />
                                    <Typography style={{ marginLeft: '10px' }}>
                                        Буцах
                                    </Typography>
                                </Button>
                            </Grid>
                            <Grid item>
                                Төлөв <Switch checked={initialData.active} onClick={handleToggle} />
                                <Button
                                    color="success"
                                    style={{ marginLeft: '10px' }}
                                    type="submit"
                                    variant="outlined"
                                >
                                    <SaveAltIcon />
                                    <Typography style={{ marginLeft: '10px' }}>
                                        Хадгалах
                                    </Typography>
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </form>

            {isEdit && (
                <Dialog
                    open={showDeleteValidation}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        Та энэхүү мэдээллийг устгахыг хүсэж байна уу?
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Та энэ мэдээллийг устгахыг хүсэж байвал
                            &apos;Тийм&apos; товчийг дарна уу.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setShowDeleteValidation(false)}>
                            Болих
                        </Button>
                        <Button color="error" onClick={handleDelete} autoFocus>
                            Тийм
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    );
}
